var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import { Button, Link } from "@riseart/common";
import { filterClearBtnCls } from "./Clear.less";
var FilterClearButton = /* @__PURE__ */ __name(function FilterClearButton2(_ref) {
  var _ref$url = _ref.url, url = _ref$url === void 0 ? "/" : _ref$url, _ref$size = _ref.size, size = _ref$size === void 0 ? "small" : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$totalActiveFilte = _ref.totalActiveFilters, totalActiveFilters = _ref$totalActiveFilte === void 0 ? 0 : _ref$totalActiveFilte, _ref$displayAsButton = _ref.displayAsButton, displayAsButton = _ref$displayAsButton === void 0 ? false : _ref$displayAsButton;
  if (!totalActiveFilters) {
    return null;
  }
  var Component = displayAsButton ? Button : Link;
  var componentProps = displayAsButton ? {
    isAnchor: true,
    size,
    type: "secondary",
    width: "auto"
  } : {
    type: "strong"
  };
  return /* @__PURE__ */ React.createElement(Component, _extends({}, componentProps, {
    to: url,
    title: title || children,
    className: filterClearBtnCls
  }), children);
}, "FilterClearButton");
export {
  FilterClearButton
};
